import axios from 'axios'

import { useTokenStore, useUserInfoStore, usePromoterInfoStore } from '@/stores'

import wx from 'weixin-js-sdk'

// 存储所有正在进行的请求控制器
const pendingRequests = new Map()

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_API_PREFIX || '/prod-api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 生成请求唯一标识
const generateRequestKey = (config) => {
  let requestKey = `${config.method}_${config.url}_${JSON.stringify(config.params)}_${JSON.stringify(config.data)}`

  // 查看 formData 信息
  if (config?.data instanceof FormData) {
    for (let [key, value] of config.data.entries()) {
      requestKey = `${requestKey}_${key}_${value.name}`
    }
  }

  return requestKey
}

// 添加请求到待处理列表
function addPendingRequest(config) {
  const requestKey = generateRequestKey(config)
  // 如果已经存在，先取消之前的请求
  if (pendingRequests.has(requestKey)) {
    const controller = pendingRequests.get(requestKey)
    controller?.abort()
    // config?.abort()
  }

  // 创建新的控制器
  const controller = new AbortController()
  config.signal = controller.signal

  pendingRequests.set(requestKey, controller)
}

// 定时器
let timer = null
// 定时检查待处理列表，并移除已经完成的请求
const cancelTimer = () => {
  clearInterval(timer)
  timer = setTimeout(() => {
    // 延迟检查待处理列表，并移除提示
    if (pendingRequests.size == 0) {
      toast.close()
      clearInterval(timer)
      timer = null
    }
  }, 1000)
}

// 移除已完成的请求
function removePendingRequest(config) {
  const requestKey = generateRequestKey(config)
  pendingRequests.delete(requestKey)
  cancelTimer()
}

// 取消所有请求
export const cancelAllRequests = () => {
  pendingRequests.forEach((controller) => {
    controller.abort()
  })
  pendingRequests.clear()
  clearInterval(timer)
  toast.close()
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 添加请求到待处理列表
    addPendingRequest(config)
    if (pendingRequests.size > 0) {
      // toast.loading()
    }

    // 可以在这里添加认证token等
    const { getToken, getRefreshtoken, removeAll } = useTokenStore()

    const token = getToken
    const refreshtoken = getRefreshtoken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.Refreshtoken = `${refreshtoken}`
    }

    // 如果是 FormData，让浏览器自动设置 Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    removePendingRequest(response.config)

    const { code, data, message } = response.data

    if (code === 200) {
      // 确保返回类型匹配
      return response.data
    } else if (code === 401) {
      const { removeAll: removeToken } = useTokenStore()
      const { removeAll: removeUserInfo } = useUserInfoStore()
      const { removeAll: removePromoterInfo } = usePromoterInfoStore()
      removeToken()
      removeUserInfo()
      removePromoterInfo()
      wx.miniProgram.navigateTo({
        url: '/my/address/index?fromOrder=1&H5Path=/certification',
      })
      return Promise.reject(new Error('token失效'))
    } else {
      // 可以根据业务需求处理不同的错误码
      toast.close()
      toast.error(message || '请求失败')
      return Promise.reject(new Error(message || '请求失败'))
    }
  },
  (error) => {
    removePendingRequest(error.config)
    // 如果是取消请求的错误，直接返回
    if (error.message == 'canceled') {
      return Promise.reject(error)
    }
    let message = error.response.data.message
    toast.error(message || '网络异常，请稍后再试')
    return Promise.reject(error)
  },
)

export default request
